import { FilterFieldValue } from '../covance-filter';
import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { EQueryTab } from './models/e-query-tab.enum';
import { ExternalUserEQuery } from './models/external-user-e-query';
import { ExternalUserEQueriesFilter } from './models/external-user-e-queries-filter';

export interface ExternalUserEQueriesStorage<T extends ExternalUserEQuery = ExternalUserEQuery> {
    getEQueryFilterItems(data$: Observable<[number, EQueryTab]>): Observable<ExternalUserEQueriesFilter[]>;
    getEQueries(siteId: number, tab: EQueryTab, filterFields: FilterFieldValue[]): Observable<T[]>;
}

export const EQUERIES_STORAGE = new InjectionToken<ExternalUserEQueriesStorage>('EQueriesStorage');
